import { defineStore } from "pinia";
import { ref, computed } from "vue";

const TOKEN_KEY = "ecosa_pm_token";

export interface MeUser {
  id: number;
  email: string;
  display_name: string;
}

export const useAuthStore = defineStore("auth", () => {
  const token = ref<string | null>(localStorage.getItem(TOKEN_KEY));
  const me = ref<MeUser | null>(null);

  const isAuthenticated = computed(() => !!token.value);

  function setToken(newToken: string) {
    token.value = newToken;
    localStorage.setItem(TOKEN_KEY, newToken);
  }

  function setMe(user: MeUser) {
    me.value = user;
  }

  function logout() {
    token.value = null;
    me.value = null;
    localStorage.removeItem(TOKEN_KEY);
  }

  return { token, me, isAuthenticated, setToken, setMe, logout };
});
